import styled, { css } from 'styled-components';
import { devices } from '../../../../core/breakpoints';

export const StyledGridKpiCard = styled.div`
  height: 100%;
  & > div {
    height: 100%;
  }
  &.disableCardEvents * {
    pointer-events: none;
    user-select: none;
  }
`;

export const ReportGridKpiCard = styled.div`
  display: flex;
  flex-direction: column;
  &.disableCardEvents * {
    pointer-events: none;
    user-select: none;
  }
  padding-bottom: 5px;
`;

export const Comment = styled.p`
  font-size: 1rem;
  text-align: justify;
  white-space: break-spaces;
  margin: 2px 0;
  padding: 5px 3px;
  ${(props) => props.isOwner && props.story && css`
    cursor: pointer;
    &:hover {
      background-color: lightgrey;
    }
  `}
`;

export const MenuCard = styled.div`
  user-select: none;
  display: flex;
  padding: 5px;
  box-sizing: border-box;
  margin: 0px;
  /* position: absolute; */
  visibility: visible;
  right: 0px;
  top: 0px;
  bottom: 0px;
  height: 100%;
  flex-direction: column;
  background-color: ${({ theme }) => theme.popoverBackground};
  & .menuItemBottom {
    margin-top: auto;
  }
  & .kpi-options {
    @media ${devices.tablet} {
      transform: rotate(0) !important;
    }
  }
`;

export const EmptyReportCard = styled.div`
  box-sizing: border-box;
  min-height: 240px;
  padding: 28px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  text-align: center;
  color: ${({ theme }) => theme.color};
  background: ${({ theme }) => theme.tableBackground};
  border: 1px dashed ${({ theme }) => theme.containerLine};
  border-radius: 12px;

  .empty-report-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border-radius: 12px;
    background: ${({ theme }) => theme.controllersLabel};
    color: ${({ theme }) => theme.primary};
  }
  .empty-report-icon svg {
    width: 28px;
    height: 28px;
    fill: currentColor;
  }
  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
  }
  p {
    margin: 0;
    max-width: 380px;
    font-size: 13px;
    line-height: 1.6;
  }
  button {
    margin-top: 4px;
  }
  button:focus-visible {
    outline: 3px solid ${({ theme }) => theme.warning};
    outline-offset: 3px;
  }
`;
